import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";
import AddPlatformModal from "../Modal/AddPlatformModal";

const CustomNodePlatformData = ({ id, data, onChange }) => {
  const [platform, setplatform] = useState(data);
  const [platformData, setPlatformData] = useState();
  const [addPlatfromData, SetAddPlatfromData] = useState();

  useEffect(() => {
    const result = async () => {
      const platformResponse = await fetchPlatformConfigs();
      setPlatformData(platformResponse?.data?.items);
    };

    result();
  }, []);
  const handlePlatfrom = () => {
    SetAddPlatfromData((state) => !state);
  };


  const handlePlatformChange = (event) => {
    const selectedPlatform = event.target.value;
    let selectedData = { id: "" };
    if (selectedPlatform !== "") {
      selectedData =
        platformData &&
        platformData.find((p) => p.id === parseInt(selectedPlatform));
    }
    setplatform(selectedPlatform);

    if (onChange) {
      onChange(id, selectedData);
    }
  };
  return (
    <>
      <div className="custom-node">
        <div className="node-header">
          PLATFORM
          {/* <i
            className=" fa fa-plus"
            style={{ marginLeft: "4rem" }}
            onClick={handlePlatfrom}
          ></i> */}
        </div>

        {/* <select value={platform.dataset_id} onChange={handlePlatformChange}>
          <option value="">Select</option>
          {platformData &&
            platformData.map((data) => (
              <option value={data.dataset_id} id={data.dataset_id}>
                {data.name}
              </option>
            ))}
        </select> */}

        <div className="name">{data?.name}</div>
        <div >{data?.ip}</div>

        <Handle type="target" position="left" />
        <Handle type="source" position="right" />
      </div>

      {addPlatfromData && (
        <AddPlatformModal
          ModalState={addPlatfromData}
          handleClose={handlePlatfrom}
          // setUpdate={setUpdate}
          editData={{}}
        />
      )}
    </>
  );
};

export default CustomNodePlatformData;
